import script from "./danh-sach-nguoi-dung.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-nguoi-dung.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-nguoi-dung.vue?vue&type=style&index=0&id=189d0152&scoped=true&lang=css"
/* custom blocks */
import block0 from "./nguoidung.scss?vue&type=custom&index=0&blockType=link&issuerPath=D%3A%5Cvsts-agent%5C_work%5C42%5Cs%5Csrc%5Cviews%5Cusers%5Cdanh-sach-nguoi-dung.vue"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189d0152"]])

export default __exports__